import React from "react";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: 'column',
        padding: '17px 25px 45px 25px',
        width: 'auto',
        marginTop: '30px',
        marginBottom: '30px',
        width: 600,
        maxWidth: '95%',
        margin: 'auto',
        borderRadius: 5,
        boxShadow: '1px 1px 10px rgba(0,0,0,0.1)',
        textAlign:'center',
        '@media (max-width: 550px)': {
            width: '100%',
            maxWidth: '100%',
        },
    },
    title: {
        margin: '15px 0px 25px 0px',
        fontSize: '21px',
        fontWeight: 'bold'
    },
    videos: {
        width: 500,
        height: 'auto',
        maxWidth: '98%',
    },
    images:{
        width:100,
    }


}));

export default function Index() {

    const classes = useStyles()

    return (
        <div className={classes['root']}>
            <div className={classes['gridImages']}>
                <img src="/assets/images/newImages/11.png" alt="" className={classes['images']} />
            </div>
            <div>
                <h3 className={classes['title']}>
                    آموزش ثبت‌نام سهام عدالت متوفیان
                </h3>
            </div>
            <video controls className={classes['videos']}>
                <source src={'/assets/videos/motionSaham.mp4'} type="video/mp4" />
                مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
            </video>
        </div>
    );
}

